module.exports = __webpack_public_path__ + "static/media/SurveyScreen.80737a94.png";